import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-similar-videos',
    templateUrl: './similar-videos.component.html',
    styleUrls: ['./similar-videos.component.scss'],
    imports: [RouterModule]
})
export class SimilarVideosComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
